<template>
  <DynamicModal
    :showModal="showEditModal"
    :persistent="false"
    @clickOutside="closeModal"
    title="Edit Expense"
    maxWidth="800px"
  >
    <v-container fluid slot="title-buttons" class="py-1">
      <v-row justify="end">
        <v-btn
          icon
          depressed
          color="primary"
          @click="closeModal"
        >
          <v-icon color="white">close</v-icon>
        </v-btn>
      </v-row>
    </v-container>
    <v-container fluid slot="content">
      <v-form ref="editExpenseForm">
        <div v-if="showActive">
          <v-row class="mt-3">
            <v-col cols="8" sm="10">
              <v-text-field
                v-model="expenseToEdit.expenseName"
                label="Name"
                validate-on-blur
                outlined
                :rules="[required('Name')]"
              ></v-text-field>
            </v-col>
            <v-col cols="4" sm="2">
              <v-checkbox
                label="Active"
                v-model="expenseToEdit.active"
              ></v-checkbox>
            </v-col>
            <v-col cols="6" sm="4">
              <FormattedNumberField
                label="Amount"
                :value="expenseToEdit.amount"
                :required="true"
                prepend-inner-icon="attach_money"
                @valueChange="(newValue) => this.expenseToEdit.amount = newValue"
              ></FormattedNumberField>
            </v-col>
            <v-col cols="6" sm="4" v-if="showExpenseAmountType">
              <ExpenseAmountTypesDropdownList
                :expenseAmountTypeId="expenseToEdit.expenseAmountTypeId"
                :isRequired="true"
                @expenseAmountTypeIdChange="(newValue) => this.expenseToEdit.expenseAmountTypeId = newValue"
              ></ExpenseAmountTypesDropdownList>
            </v-col>
            <v-col cols="6" sm="4">
              <ExpensesTypesDropdownList
                :expenseTypeId="expenseToEdit.expenseTypeId"
                :isRequired="true"
                @expenseTypeIdChange="(newValue) => this.expenseToEdit.expenseTypeId = newValue"
              ></ExpensesTypesDropdownList>
            </v-col>
          </v-row>
        </div>
        <div v-if="!showActive">
          <v-row class="mt-3">
            <v-col cols="12">
              <v-text-field
                v-model="expenseToEdit.expenseName"
                label="Name"
                validate-on-blur
                outlined
                :rules="[required('Name')]"
              ></v-text-field>
            </v-col>
            <v-col cols="6" sm="4">
              <FormattedNumberField
                label="Amount"
                :value="expenseToEdit.amount"
                :required="true"
                prepend-inner-icon="attach_money"
                @valueChange="(newValue) => this.expenseToEdit.amount = newValue"
              ></FormattedNumberField>
            </v-col>
            <v-col cols="6" sm="4" v-if="showExpenseAmountType">
              <ExpenseAmountTypesDropdownList
                :expenseAmountTypeId="expenseToEdit.expenseAmountTypeId"
                :isRequired="true"
                @expenseAmountTypeIdChange="(newValue) => this.expenseToEdit.expenseAmountTypeId = newValue"
              ></ExpenseAmountTypesDropdownList>
            </v-col>
            <v-col cols="6" sm="4">
              <ExpensesTypesDropdownList
                :expenseTypeId="expenseToEdit.expenseTypeId"
                :isRequired="true"
                @expenseTypeIdChange="(newValue) => this.expenseToEdit.expenseTypeId = newValue"
              ></ExpensesTypesDropdownList>
            </v-col>
          </v-row>
        </div>
      </v-form>
    </v-container>
    <v-container fluid slot="buttons" class="pb-0 mb-0">
      <div class="row d-flex justify-end">
        <div class="col-6">
          <v-btn
            block
            depressed
            color="primary"
            @click="editExpense"
          >
            Edit
          </v-btn>
        </div>
        <div class="col-6">
          <v-btn
            block
            depressed
            outlined
            @click="closeModal"
          >
            Cancel
          </v-btn>
        </div>
      </div>
    </v-container>
  </DynamicModal>
</template>

<script>
import DynamicModal from '@/components/dialogs/DynamicModal'
import ExpensesTypesDropdownList from '@/components/expenses/ExpensesTypesDropdownList'
import ExpenseAmountTypesDropdownList from '@/components/expenses/ExpenseAmountTypesDropdownList'
import { required } from '@/lib/formValidations'
import { FormattedNumberField } from '@/components/shared/textFields'

export default {
  components: {
    DynamicModal,
    ExpensesTypesDropdownList,
    ExpenseAmountTypesDropdownList,
    FormattedNumberField
  },
  props: [
    'showActive',
    'showExpenseAmountType'
  ],
  data () {
    return {
      showEditModal: false,
      expenseToEdit: {}
    }
  },
  methods: {
    required,
    clearExpense () {
      this.expenseToEdit = {
        expenseName: null,
        expenseTypeId: null,
        amount: null,
        expenseAmountTypeId: null
      }
    },
    showModal () {
      this.showEditModal = true
    },
    closeModal () {
      this.clearExpense()
      this.showEditModal = false
    },
    editExpense () {
      if (this.$refs.editExpenseForm.validate()) {
        this.$emit('expenseChange', this.expenseToEdit)
        this.clearExpense()
        this.showEditModal = false
      }
    },
    setExpenseToEdit (expenseToEdit) {
      this.expenseToEdit = { ...expenseToEdit }
    }
  }
}
</script>
